import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

const baseURL = process.env.PUBLIC_URL + '/assets/';

const CombinedComponent = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const location = useLocation();

  const subMenus = {
    school: [
      { title: "House System", link: "/StudentLifePage" },
      { title: "Gallery", link: "/GalleryPage" },
      { title: "Infrastructure", link: "/InfraPage" },
      { title: "Uniform", link: "/UniformPage" },
      { title: "Rules & Regulations", link: "/RulesPage" },
      { title: "Visiting Hours", link: "/VistingHourPage" }
    ],
    about: [
      { title: "Mission & Vision", link: "/MissionAndVisionPage" },
      { title: "SMC", link: "/SMCPage" },
      { title: "Mandatory Public Disclosure", link: "/Mpd" },
      { title: "Contact Us", link: "/ContactUsPage" }
    ],
    admissions: [
      { title: "Fees Chart", link: "/FeesPage" },
      { title: "Admission Enquiry", link: "/AdmissionEnquiryPage" },
      { title: "TC", link: "/TCPage" }
    ],
    academics: [
      { title: "Faculty", link: "/FacultyPage" },
      { title: "Calendar", link: "/GalleryPage" }
    ]
  };

  const toggleMenu = () => {
    const newMenuOpenState = !menuOpen;
    setMenuOpen(newMenuOpenState);
    if (newMenuOpenState) {
      // Find the submenu that corresponds to the current page
      const currentPath = location.pathname;
      const subMenuToOpen = ["school", "about", "admissions", "academics"].find(menu => {
        return subMenus[menu].some(item => item.link === currentPath);
      });
      setOpenSubMenu(subMenuToOpen);
    } else {
      setOpenSubMenu(null);
    }
  };

  const handleSubMenuClick = (subMenuName) => {
    setOpenSubMenu(openSubMenu === subMenuName ? null : subMenuName);
  };

  const handleCrossClick = () => {
    setMenuOpen(false);
    setOpenSubMenu(null);
  };

  return (
    <div className="fixed top-0 left-0 z-50 flex flex-col pt-3.5 bg-footer-blue-custom w-full" style={{ maxWidth: '100vw' }}>
      <div className="flex flex-col px-7 w-full font-bold text-white capitalize">
        <div className="flex gap-5 justify-between w-full text-xs tracking-wide">
          <NavLink to="/">
            <div className="flex gap-2">
              <img
                loading="lazy"
                src={`${baseURL}/Logo.jpg`}
                className="shrink-0 w-6 rounded-full"
              />
              <div className="grow my-auto">Motherland Children Academy</div>
            </div>
          </NavLink>
          <div>
            <button onClick={toggleMenu} className="text-neutral-100 focus:outline-none">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d={menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"}
                />
              </svg>
            </button>
          </div>
        </div>
        <div className="flex gap-3 mt-4 text-xs tracking-normal pb-5">
          <NavLink to="/Mpd">
            <div className="grow justify-center px-3 py-2 rounded-lg bg-zinc-800">
              Mandatory Public Disclosure
            </div>
          </NavLink>
          <NavLink to="/AdmissionEnquiryPage">
            <div className="grow justify-center px-3 py-2 rounded-lg bg-zinc-800">
              Admission Enquiry
            </div>
          </NavLink>
        </div>
      </div>
      {menuOpen && (
        <div className="flex flex-col w-1/2 h-full fixed right-0 top-0 bg-white">
          <img
            loading="lazy"
            src={`${baseURL}close.svg`}
            className="w-6 aspect-square m-2 cursor-pointer"
            onClick={handleCrossClick} // Close the menu when clicking the image
          />
          <SubMenu
            title="The School"
            isOpen={openSubMenu === "school"}
            onClick={() => handleSubMenuClick("school")}
            subMenuItems={subMenus.school}
          />
          <SubMenu
            title="About Us"
            isOpen={openSubMenu === "about"}
            onClick={() => handleSubMenuClick("about")}
            subMenuItems={subMenus.about}
          />
          <SubMenu
            title="Admissions"
            isOpen={openSubMenu === "admissions"}
            onClick={() => handleSubMenuClick("admissions")}
            subMenuItems={subMenus.admissions}
          />
          <SubMenu
            title="Academics"
            isOpen={openSubMenu === "academics"}
            onClick={() => handleSubMenuClick("academics")}
            subMenuItems={subMenus.academics}
          />
        </div>
      )}
    </div>
  );
};

const SubMenu = ({ title, isOpen, onClick, subMenuItems }) => {
  const location = useLocation();

  return (
    <div className="flex flex-col justify-center mt-4 w-full border-b border-solid border-neutral-200">
      <div className={`flex gap-5 justify-start px-4 py-2 pt-0 w-full border-b border-solid border-neutral-200 ${isOpen ? 'bg-blue-200 rounded-lg pt-2' : ''}`}>
        <NavLink className="text-xs font-bold text-left tracking-wide text-black capitalize self-start" onClick={onClick}>{title}</NavLink>
        <div className="flex overflow-hidden relative flex-col justify-center items-center my-auto w-3 aspect-square ml-auto" onClick={onClick}>
          {isOpen ? (
            <img
              loading="lazy"
              src={`${baseURL}down.svg`}
              className={`object-cover absolute inset-0 size-full ${isOpen ? 'rotate-180' : ''} cursor-pointer transition-transform`}
              alt="submenu-arrow"
            />
          ) : null}
          {isOpen ? null : (
            <img
              loading="lazy"
              src={`${baseURL}down.svg`}
              className="w-full aspect-square cursor-pointer "
              alt="school-image"
            />
          )}
        </div>
      </div>
      {isOpen && (
        <div className=" px-4 pb-2 flex flex-col text-xs font-bold tracking-wide capitalize text-neutral-600">
          {subMenuItems.map((item, index) => (
            <NavLink key={index} to={item.link} className={`block mt-3 hover:text-blue-500 ${item.link === location.pathname ? 'text-blue-700 font-semibold' : ''}`}>{item.title}</NavLink>
          ))}
        </div>
      )}
    </div>
  );
};

export default CombinedComponent;
